(function () {
  const DESKTOP_QUERY = '(min-width: 990px)';

  function syncEliteCartSummaryDock() {
    const footer = document.getElementById('main-cart-footer');
    const form = document.getElementById('cart');
    const cartItems = document.querySelector('cart-items');

    if (!footer || !form || !cartItems) return;

    const wrapper = footer.closest('.cart__footer-wrapper');
    if (!wrapper) return;

    let anchor = wrapper.querySelector('[data-elite-cart-summary-anchor]');
    if (!anchor) {
      anchor = document.createElement('div');
      anchor.dataset.eliteCartSummaryAnchor = 'true';
      anchor.hidden = true;
      wrapper.insertBefore(anchor, footer);
    }

    const shouldDock =
      window.matchMedia(DESKTOP_QUERY).matches &&
      !cartItems.classList.contains('is-empty') &&
      !footer.classList.contains('is-empty');

    if (shouldDock) {
      if (footer.parentElement !== form) {
        form.appendChild(footer);
      }
      footer.classList.add('is-docked');
      form.classList.add('cart__contents--docked-summary');
      wrapper.classList.add('is-detached');
      return;
    }

    if (footer.parentElement !== wrapper) {
      wrapper.insertBefore(footer, anchor.nextSibling);
    }

    footer.classList.remove('is-docked');
    form.classList.remove('cart__contents--docked-summary');
    wrapper.classList.remove('is-detached');
  }

  window.syncEliteCartSummaryDock = syncEliteCartSummaryDock;

  document.addEventListener('DOMContentLoaded', syncEliteCartSummaryDock);
  document.addEventListener('shopify:section:load', syncEliteCartSummaryDock);
  window.addEventListener('resize', syncEliteCartSummaryDock);
})();
